"use client";

import { INITIAL_CONTEXT_COOKIE_NAME } from "../constants";
import { DefaultInitialContext } from "../types";

// Utility functions for client-side cookie handling

export function clearAllCookies(): void {
  if (typeof document === "undefined") return;

  document.cookie.split(";").forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    // Trim leading whitespace from cookie name
    const name = (eqPos > -1 ? cookie.substring(0, eqPos) : cookie).trim();
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
}

// The below functions are only used for CI. Use InitialContextProvider and useInitialContext hook
// instead of calling these directly

export function __getCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;

  const allCookies = document.cookie;

  const value = `; ${allCookies}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(";").shift();
    return cookieValue;
  }
  console.log(`[getCookie] Cookie "${name}" not found`);
  return undefined;
}

export function __setContextCookie(
  value: string,
  options: { path?: string; maxAge?: number } = {},
  name = INITIAL_CONTEXT_COOKIE_NAME
): void {
  if (typeof document === "undefined") return;

  const { path = "/", maxAge = 86400 * 7 } = options; // Default 7 days
  const cookieString = `${value}; path=${path}; max-age=${maxAge}; SameSite=Lax`;

  // Write to the specified cookie name (new by default)
  document.cookie = `${name}=${cookieString}`;

  // Also write to legacy cookie for backward compatibility
  if (name === INITIAL_CONTEXT_COOKIE_NAME) {
    document.cookie = `${INITIAL_CONTEXT_COOKIE_NAME}=${cookieString}`;
  }
}

// Get context data from cookie
export function __getContextCookie(): DefaultInitialContext | null {
  try {
    // Try new cookie name first, then fallback to legacy name
    let cookieData = __getCookie(INITIAL_CONTEXT_COOKIE_NAME);
    if (!cookieData) {
      cookieData = __getCookie(INITIAL_CONTEXT_COOKIE_NAME);
    }
    if (!cookieData) return null;

    return JSON.parse(decodeURIComponent(cookieData));
  } catch (error) {
    console.error("Failed to get context from cookie:", error);
    return null;
  }
}
